import { LegacyDashboard } from './LegacyDashboard';
import { PivotDashboard } from './PivotDashboard';

// ALM-368: hard-coded switch. false restores the pre-pivot dashboard.
const USE_PIVOT_DASHBOARD = true;

export function DashboardHomePage() {
  return USE_PIVOT_DASHBOARD ? <PivotDashboard /> : <LegacyDashboard />;
}
